export const escape = (content) => {
  const div = document.createElement("div");
  div.textContent = content;
  return div.innerHTML;
};

export const defaults = (type = "location") => ({
  delay: 750,
  clearButton: false,
  howManyCharacters: 3,
  selectFirst: true,

  onRender: ({ results }) => {
    const text =
      type === "address" ? "Pick an address from the list" : "Pick a location from the list";
    results.insertAdjacentHTML(
      "beforebegin",
      `<div class="px-4 py-2 text-xs text-gray-400 border-b border-gray-100">${text}</div>`,
    );
  },

  onLoading: ({ currentValue }) => {
    const noun = type === "address" ? "addresses" : "locations";
    return `<li class="px-4 py-3 text-gray-600">Searching ${noun} for &ldquo;${escape(currentValue)}&rdquo;&hellip;</li>`;
  },

  onResults: ({ currentValue, matches, template, classGroup }) => {
    if (matches === 0) {
      return template;
    }

    const regex = new RegExp(currentValue, "gi");

    return matches
      .map((result) => {
        return `
              <li class="[&.auto-selected]:bg-teal [&.auto-selected]:text-white">
                <span class="hidden">${result.place_name || result.route}</span>
                <div class="flex items-center justify-between gap-2 w-full px-4 py-3 cursor-pointer text-gray-600 [.auto-selected_&]:text-white">
                  <div>
                    <div class="truncate">${escape(result.place_name || result.route).replace(regex, (str) => `<mark>${str}</mark>`)}</div>
                    ${result.type === "region" ? `<div class="text-sm">Region</div>` : ""}
                  </div>
                </div>
              </li>
            `;
      })
      .join("");
  },

  noResults: ({ currentValue, template }) => {
    return template(`<div class="px-4 py-2 text-gray-600">No locations match your query.</div>`);
  },
});
